import React, { useState, useEffect, useContext } from "react";
import {
  Label,
  Form,
  FormGroup,
  Row,
  Col,
  Input,
  InputGroup,
} from "reactstrap";
import { useController, useForm } from "react-hook-form";
import AsyncSelect, { useAsync } from "react-select/async";
import Select from "react-select";
import { Button } from "@mui/material";
import AddBoxIcon from "@mui/icons-material/AddBox";
import { showAlert } from "../../../Services/Shared.service";
import Checkbox from "@mui/material/Checkbox";
import CustomizerContext from "../../../_helper/Customizer";
import SharedDataContext from "../../../_helper/SharedData";
import { getDriverSchemes, getDriverSchemeById,createDriverScheme,updateDriverScheme } from "../../../Services/Driver.service";
import { get } from "lodash";
const DriverSchemeForm = ({isSearch, setIsSearch,setDriverScheme,setNewDriverSchemeFlow}) => {
  const {
    register,
    control,
    handleSubmit,
    formState: { errors },
    setValue,
    getValues,
    reset,
    watch
  } = useForm({
    defaultValues: {},
  });

  const { ServiceCity } = watch()
  const {setTabValue} = useContext(SharedDataContext)
  const {mix_background_layout} = useContext(CustomizerContext)
  const {cityData} = useContext(SharedDataContext)
  // const [isSearch, setIsSearch] = useState(true);
  // const [isSubmitting, setIsSubmitting] = useState(false);
  const [editId,setEditId] = useState(null);
  const [schemeList,setSchemeList] = useState([]);
  const [selectedScheme,setSelectedScheme] = useState({})


const isSubscription = useController({
  name: "isSubscription",
  control,
}).field;

const isHide = useController({
  name: "isHide",
  control,
}).field;


  useEffect(() => {
    if(selectedScheme !== null){
      // console.log("selectedScheme.hide",selectedScheme.hide);
      reset({
        name:selectedScheme?selectedScheme.name:"",
        ServiceCity:cityData.find(element =>element.id === selectedScheme.serviceCityId),
        isSubscription:selectedScheme.isSubscription,
        isHide:selectedScheme.isHide,
      })
    }
  }, [selectedScheme]);

  useEffect(()=>{
    getDriverSchemes().then((resp)=>{
      if(resp.status === 200){
        const data = []
        resp.data.forEach((element)=>{
          data.push({
            value: element,
            label: element.name,
            id: element.id,
          })
        })
        setSchemeList(data);
      }
    })
  },[])

  const handleschemeSelect = (selectedScheme) =>{
    console.log("selected scheme",selectedScheme);
    setSelectedScheme(selectedScheme.value)
    setEditId(selectedScheme.id);
    setIsSearch(false)
    setNewDriverSchemeFlow(false)
  }
  
  const handleSchemeSubmit = (formValues) => {
    console.log("formValues",formValues)

    const body ={
      name:formValues?formValues.name:"",
      serviceCityId:formValues.ServiceCity?.id ?? null,
      isSubscription:formValues.isSubscription,
      isHide:formValues.isHide,
      createdOn:selectedScheme.createdOn,
      createdById:selectedScheme.createdById,
      deletedOn:selectedScheme.deletedOn,
      deletedById:selectedScheme.deletedById
    }

    if(editId !== null){
      body["id"] = editId;
      console.log("handleSchemeSubmit",body)
      updateDriverScheme(body).then((resp)=>{
        setDriverScheme(resp.data)
        showAlert("success","Updated Successfully")
        setIsSearch(true)
        setTabValue(prev=>prev+1)
        setEditId(null)
      }).catch((err)=>{
        showAlert("error","Something went wrong")
      })

    }else{
      createDriverScheme(body).then((resp)=>{
        if(resp.status == 200){
          setDriverScheme(resp.data)
          showAlert("success","Driver Scheme created successfully")
          setIsSearch(true);
          setTabValue(prev=>prev+1)
        }
      }).catch((err)=>{
        showAlert("error","Something went wrong");
      })
    }

    console.log("DriverScheme",formValues)
  };

  const handleNewClick =()=>{
    reset({
      name:"",
      serviceCityId:"",
      isSubscription:false,
      isHide:false,
    })
    setIsSearch(false);
    setEditId(null);
    setNewDriverSchemeFlow(true)
  }

  return (
    <div>
      {isSearch ? (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <div
            style={{
              width: "400px",
              display: "flex",
              flexDirection: "column",
              gap: "20px",
            }}
          >
            <Button
              sx={{
                width: "100%",
                fontSize: "1rem",
                color: "#41CC7D",
                borderColor: "#41CC7D",
                "&:hover": {
                  borderColor: "#41CC7D",
                },
              }}
              variant="outlined"
              startIcon={<AddBoxIcon sx={{ color: "#41CC7D" }} />}
              onClick={() => {
                handleNewClick()
              }}
            >
              New Driver Scheme
            </Button>

            <Select
            cacheOptions
            options={schemeList}
            placeholder={"Select Driver Scheme"} 
            onChange={handleschemeSelect}
            />
          </div>

        </div>
      ) : (
        <div>
          <Form onSubmit={handleSubmit(handleSchemeSubmit)}>
            <Row>
              <FormGroup className="col-lg-4">
                <Label className="col-lg-12 col-form-label">Name</Label>
                <Col lg="12">
                  <input
                    className="form-control"
                    type="text"
                    {...register("name", {
                      required: {
                        value: true,
                        message: "Name is required",
                      },
                      onChange: (e) => {
                        setValue("name", e.target.value.trimStart());
                      },
                    })}
                  />
                  <span style={{ color: "red" }}>
                    {errors?.name?.message}
                  </span>
                </Col>
              </FormGroup>
              <FormGroup className="col-lg-4">
                <Label className="col-lg-12 col-form-label">Service City</Label>
                <Col lg="12">
                  <Select
                  value={ServiceCity?ServiceCity:{ label: "Select Service City", value: "" }}
                    options={cityData}
                    {...register("ServiceCity", {
                      required: {
                        value: editId === null,
                        message: "Service City Required",
                      },
                    })}
                    
                    onChange={(e) => {
                      setValue("ServiceCity", e);
                    }}
                    placeholder={"Select Service City"}
                    isDisabled={editId !== null}
                  />
                  <span style={{ color: "red" }}>
                    {errors?.ServiceCity?.message}
                  </span>
                </Col>
              </FormGroup>
              
            <FormGroup
              className="col-lg-4"
              style={{ display: "flex", alignItems: "center" }}
            >
              <div
                style={{ display: "flex", alignItems: "center" }}
                className={
                  mix_background_layout == "dark-only"
                    ? "checkbox-dark p-0"
                    : "checkbox p-0"
                }
              >
                <Input
                  id="IsActive"
                  type="checkbox"
                  checked={isSubscription.value}
                  onChange={(value) => isSubscription.onChange(value)}
                />
                <Label className="mb-0" for="IsActive">
                  {"IsSubscription"}
                </Label>
              </div>
            </FormGroup>

            <FormGroup
              className="col-lg-4"
              style={{ display: "flex", alignItems: "center" }}
            >
              <div
                style={{ display: "flex", alignItems: "center" }}
                className={
                  mix_background_layout == "dark-only"
                    ? "checkbox-dark p-0"
                    : "checkbox p-0"
                }
              >
                <Input
                  id="IsKiosk"
                  type="checkbox"
                  checked={isHide.value}
                  onChange={(value) => isHide.onChange(value)}
                />
                <Label className="mb-0" for="IsKiosk">
                  {"IsHide"}
                </Label>
              </div>
            </FormGroup>
              {/* <FormGroup className="col-lg-2" style={{ display: "flex", alignItems: "center" }}>
                      <div style={{ display: "flex", alignItems: "center" }} className={mix_background_layout == "dark-only" ? "checkbox-dark p-0" : "checkbox p-0"}>
                        <Input id="isSubscription" type="checkbox"
                        checked={isSubscription}
                        {...register("isSubscription",{
                        })}
                                onChange={(e) => {
                            console.log("checked",e.target.value === "on" ?true:false)

                                  setValue("isSubscription",e.target.value === "on" ?true:false)

                                }} />
                        <Label className="mb-0" for="isSubscription">{"isSubscription"}</Label>
                    </div>
              </FormGroup>
              <FormGroup className="col-lg-2" style={{ display: "flex", alignItems: "center" }}>
                        <div style={{ display: "flex", alignItems: "center" }} className={mix_background_layout == "dark-only" ? "checkbox-dark p-0" : "checkbox p-0"}>
                          <Input id="isHide" type="checkbox" 
                           checked={isHide}
                           {...register("isHide",{
                           })}
                           onChange={(e)=>{
                            console.log("checked",e.target.value === "on" ?true:false)
                            setValue("isHide",e.target.value === "on" ?true:false)
                           }}
                           />
                    <Label className="mb-0" for="isHide">{"isHide"}</Label>
                  </div>
              </FormGroup> */}

        </Row>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              marginTop: "3rem",
              gap:"1rem"
            }}
          >
              <button type="button"  className="btn submit-button" onClick={()=>setIsSearch(true)}>Back</button>
             <button type="submit" className="btn submit-button" >
              {"Next"}
            </button>
          </div>
        </Form>
        </div>
      )}
    </div>
  );
};

export default DriverSchemeForm;